import * as Cookie from 'app/packages/cookie-utils';

const googleOneTapUtil = {};

const COOKIE_DISABLE_UNAUTH_GOOGLE_ONE_TAP = 'disableUnauthGoogleOneTap';

googleOneTapUtil.isGoogleOneTapDisabled = () =>
  Cookie.get(COOKIE_DISABLE_UNAUTH_GOOGLE_ONE_TAP) === '1' ||
  Cookie.get(PCONST.COOKIE_FB_AUTO_LOGIN_DISABLED);

googleOneTapUtil.disableGoogleOneTapDialog = () => {
  // Disable the Unauth Google One Tap signup feature for 7 days after user has interacted
  Cookie.set(COOKIE_DISABLE_UNAUTH_GOOGLE_ONE_TAP, '1', 24 * 7); // 24 hours per day * 7 days
};

export default googleOneTapUtil;
